import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, exhaustMap, map, of, tap } from 'rxjs';

import { ExpensesService } from 'src/app/shared/services/expenses.service';
import {
  deleteExpenses,
  editExpenses,
  loadExpenses,
  loadExpensesSuccess,
  saveExpenses,
} from './expenses.actions';
import { NotifyService } from 'src/app/shared/services/notify.service';

@Injectable()
export class ExpensesEffects {
  constructor(private service: ExpensesService, private action$: Actions, private notify: NotifyService) {}

  loadExpenses$ = createEffect(() =>
    this.action$.pipe(
      ofType(loadExpenses),
      exhaustMap(() =>
        this.service
          .getAll()
          .pipe(
            map((res) => loadExpensesSuccess({ lista: res })),
            catchError((error) => {
              this.notify.emitError('Falha ao carregar registros')
              return of(error.error['hydra:description'])
          })
          )
      )
    )
  );

  saveExpenses$ = createEffect(() =>
    this.action$.pipe(
      ofType(saveExpenses),
      concatMap(({ expenses }) =>
        this.service.save(expenses).pipe(
          tap(() => this.notify.saveSuccess()),
          map((res) => loadExpenses()),
          catchError((error) => {
            this.notify.emitError(error.error['hydra:description'])
            //console.log(error);
            return of(error.error['hydra:description']);
          })
        )
      )
    )
  );

  editExpenses$ = createEffect(() =>
    this.action$.pipe(
      ofType(editExpenses),
      concatMap(({ expenses, id }) =>
        this.service.edit(expenses, id).pipe(
          tap(() => this.notify.editSuccess()),
          map((res) => loadExpenses()),
          catchError((error) => {
            this.notify.emitError(error.error['hydra:description'])
            //console.log(error);
            return of(error.error['hydra:description']);
          })
        )
      )
    )
  );

  deleteExpenses$ = createEffect(() =>
    this.action$.pipe(
      ofType(deleteExpenses),
      concatMap(({ id }) =>
        this.service.delete(id).pipe(
          tap(() => this.notify.deleteSuccess()),
          map((res) => loadExpenses()),
          catchError((error) => {
            this.notify.emitError(error.error['hydra:description'])
            //console.log(error);
            return of(error.error['hydra:description']);
          })
        )
      )
    )
  );
}
